import React, { useState } from 'react'

interface BatchStockUpdateProps {
  onApply: (stockValue: number) => void
}

const BatchStockUpdate: React.FC<BatchStockUpdateProps> = ({
  onApply
}) => {
  const [batchValue, setBatchValue] = useState('')

  const handleApply = () => {
    const value = parseInt(batchValue)
    if (!isNaN(value) && value >= 0) {
      onApply(value)
    }
  }

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value
    // Only allow non-negative numbers
    if (value === '' || (/^\d+$/.test(value) && parseInt(value) >= 0)) {
      setBatchValue(value)
    }
  }

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      handleApply()
    }
  }

  return (
    <div className="tw-bg-gray-50 tw-p-4 tw-rounded-lg">
      <div className="tw-flex tw-flex-col sm:tw-flex-row sm:tw-items-end sm:tw-justify-between tw-gap-4">
        <div className="tw-flex-grow">
          <label 
            className="tw-block tw-text-sm tw-font-medium tw-text-gray-700" 
            htmlFor="batch-stock"
          >
            Batch Update
          </label>
          <p className="tw-text-xs tw-text-gray-500 tw-mt-1">
            Apply a single stock value to all listed variants/warehouses below.
          </p>
        </div>
        
        <div className="tw-flex tw-items-center tw-gap-2 tw-shrink-0">
          <input
            id="batch-stock"
            type="number"
            min="0"
            placeholder="e.g., 50"
            value={batchValue}
            onChange={handleInputChange}
            onKeyDown={handleKeyDown}
            className="form-input tw-w-full sm:tw-w-28 tw-rounded-md tw-border-gray-300 tw-shadow-sm focus:tw-border-primary focus:tw-ring-primary tw-text-sm"
          />
          <button
            onClick={handleApply}
            disabled={!batchValue || parseInt(batchValue) < 0}
            className="tw-flex tw-items-center tw-justify-center tw-rounded-lg tw-h-10 tw-px-4 tw-bg-primary tw-text-white tw-text-sm tw-font-bold hover:tw-bg-primary/90 tw-shrink-0 disabled:tw-bg-primary/40 disabled:tw-cursor-not-allowed"
          >
            <span className="tw-truncate">Apply</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default BatchStockUpdate